import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { ENV_CONFIG, EnvironmentConfig } from '../../environments/environment.model';
import { AvailableConfiguration, Inventtxt, ProductConfiguration } from '../models/fitting-query-params.model';
import { ODataParams, odataParamsFactory, ODataResponse } from '../models/odata-response.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationsService {

  constructor(
    private http: HttpClient,
    @Inject(ENV_CONFIG) public config: EnvironmentConfig) { }

  getConfigurations(q: ODataParams): Observable<ODataResponse<ProductConfiguration[]>> {
    const endpoint = this.config.endpoints?.baseApi;
    return this.http.get<ODataResponse<ProductConfiguration[]>>(`${endpoint.url}odata/${endpoint.version}/ProductConfigurations${q.toQuery()}`)
  }

  getSuffixes(q: ODataParams): Observable<ODataResponse<AvailableConfiguration[]>> {
    const endpoint = this.config.endpoints?.baseApi;
    return this.http.get<ODataResponse<AvailableConfiguration[]>>(`${endpoint.url}odata/${endpoint.version}/AvailableConfigurations${q.toQuery()}`);
  }

  getProducts(q: ODataParams): Observable<ODataResponse<{ itemid: string, itemname: string }[]>> {
    const endpoint = this.config.endpoints?.baseApi;
    q = odataParamsFactory({ ...q, select: ['itemid', 'itemname'] });
    return this.http.get<ODataResponse<{ itemid: string, itemname: string }[]>>(`${endpoint.url}odata/${endpoint.version}/Inventtables${q.toQuery()}`);
  }

  saveProductConfiguration(productConfiguration: ProductConfiguration): Observable<any> {
    const endpoint = this.config.endpoints?.baseApi;
    // if (!!productConfiguration.id) return this.http.patch<any>(`${endpoint.url}odata/${endpoint.version}/ProductConfigurations/${productConfiguration.id}`, productConfiguration);
    // if (!productConfiguration.id) return this.http.post<any>(`${endpoint.url}odata/${endpoint.version}/ProductConfigurations`, productConfiguration);
    return !!productConfiguration.id ?
      this.http.patch<any>(`${endpoint.url}odata/${endpoint.version}/ProductConfigurations/${productConfiguration.id}`, productConfiguration) :
      this.http.post<any>(`${endpoint.url}odata/${endpoint.version}/ProductConfigurations`, productConfiguration)
  }
}
